import { useContext } from "react";
import WishListContext from "../context/WishListContext";

const useWishList = () => {
  return useContext(WishListContext)
};

export default useWishList;